module.exports = __webpack_public_path__ + "img/3_195.5250f60d.png";